const getTagRegex = (tag) => {
    return new RegExp(`${tag}:(.*?)(?:\\||$)`);
};
export const extractGroup = (tag, input) => {
    var _a;
    if (!input) {
        return '';
    }
    const regex = getTagRegex(tag);
    const match = regex.exec(input);
    return (_a = match === null || match === void 0 ? void 0 : match[1]) !== null && _a !== void 0 ? _a : '';
};
//# sourceMappingURL=get-tagged-field-from-string.js.map